<ng-select
  class="std-skin bubble-dropdown panel-clinging"
  [appendTo]="$any(appendTo)"
  [bindLabel]="bindLabel"
  [bindValue]="bindValue"
  [class.search-in-dropdown]="showSearchInDropdown"
  [clearable]="clearable"
  [clearOnBackspace]="false"
  [dropdownPosition]="dropdownPosition"
  [closeOnSelect]="!showCheckbox"
  [loading]="loading"
  [groupBy]="groupBy"
  [groupValue]="getGroupValue"
  [selectableGroup]="true"
  [selectableGroupAsModel]="false"
  [isOpen]="isOpen"
  [items]="items"
  [disabled]="disabled"
  [multiple]="true"
  [typeahead]="$any(search$)"
  [typeToSearchText]="$any(typeToSearchText) | translate"
  [notFoundText]="notFoundText | translate"
  [placeholder]="placeholder || '' | translate"
  [(ngModel)]="selected"
  [searchFn]="searchFn"
  (add)="add.emit($event)"
  (open)="onDropdownOpen()"
  (close)="onDropdownClose()"
  (remove)="remove.emit($event)"
  (ngModelChange)="onValueChange($event)"
  [ngClass]="{ 'is-invalid': invalid }"
>
  @if (showSearchInDropdown || showAllSelection) {
    <ng-template ng-header-tmp let-searchTerm="searchTerm">
      @if (showSearchInDropdown) {
        <div
          class="input-icon mx-l6 mt-l8 mb-l12"
          id="searchInputContainer"
        >
          <svg
            class="icon-prepend text-gray-pantone"
            height="24"
            stroke="currentColor"
            stroke-width="1.5"
            width="24"
            viewBox="0 0 24 24"
            (click)="searchInput.focus()"
          >
            <use
              href="assets/images/icons/objects/search.svg#search"
            ></use>
          </svg>
          <input
            #searchInput
            class="form-control shadow-none round-input"
            placeholder="{{ 'COMMON.Search' | translate }}"
            type="text"
            [(ngModel)]="inDropdownSearch"
            (focus)="onInDropdownSearchFocus()"
            (ngModelChange)="onInDropdownSearch($event)"
          />
        </div>
      }
      @if (showAllSelection && !searchTerm && items.length > 0) {
        <div
          class="d-flex align-items-center fw-medium text-black-deep all-checkbox"
          (click)="allCheckbox.click()"
        >
          <input
            #allCheckbox
            class="form-control checkbox-default default-size me-base-l8"
            id="item-all"
            title="{{ allSelectionText | translate }}"
            type="checkbox"
            [ngModel]="isAllChecked"
            (ngModelChange)="toggleAllSelection($event)"
            (click)="$event.stopPropagation()"
          />
          <label
            for="item-all"
            class="pointer mb-0"
            (click)="allCheckbox.click()"
            >{{ allSelectionText | translate }}</label
          >
        </div>
      }
    </ng-template>
  }
  <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
    @if (showSelectedInBox) {
      @for (item of items; track item) {
        <div class="selected-item col-auto p-base-l12">
          <div
            class="std-bubble"
            [ngClass]="{
              'is-invalid':
                invalid &&
                (bindValue
                  ? invalidItems.includes(item[bindValue])
                  : invalidItems.includes(item)),
            }"
          >
            @if (showImage) {
              @if (selectedChoiceImgTemp) {
                <ng-container
                  [ngTemplateOutlet]="selectedChoiceImgTemp"
                  [ngTemplateOutletContext]="{ item: item }"
                >
                </ng-container>
              } @else {
                <ng-container
                  [ngTemplateOutlet]="conditionalImageTemp"
                  [ngTemplateOutletContext]="{
                    item: item,
                    size: 24,
                    imgClass: 'img-bubble-label-default',
                  }"
                >
                </ng-container>
              }
            }

            @if (labelTemp) {
              <ng-container
                [ngTemplateOutlet]="labelTemp"
                [ngTemplateOutletContext]="{ item: item }"
              >
              </ng-container>
            } @else {
              <span>{{
                bindLabel != null ? getLabel(item) : item
              }}</span>
            }

            @if (!disabled) {
              <button
                type="button"
                class="btn-close custom-icon text-gray-pantone ms-base-l2 p-0"
                aria-label="Close"
                (mousedown)="$event.stopPropagation()"
                (click)="clear(item)"
              >
                <svg viewBox="0 0 24 24">
                  <use
                    href="assets/images/icons/marks/x.svg#x"
                    height="24"
                    width="24"
                  ></use>
                </svg>
              </button>
            }
          </div>
        </div>
      }
    }
  </ng-template>
  <ng-template ng-option-tmp let-item$="item$">
    <div class="d-flex align-items-center fw-medium text-black-deep">
      @if (showCheckbox) {
        <input
          class="form-control checkbox-default default-size me-base-l8"
          title="{{
            bindLabel != null ? getLabel(item$.value) : item$.label
          }}"
          type="checkbox"
          [ngModel]="item$.selected"
        />
      }
      @if (showImage) {
        <div class="me-base-l8">
          @if (choiceImageTemp) {
            <ng-container
              [ngTemplateOutlet]="choiceImageTemp"
              [ngTemplateOutletContext]="{ item: item$.value }"
            >
            </ng-container>
          } @else {
            <ng-container
              [ngTemplateOutlet]="conditionalImageTemp"
              [ngTemplateOutletContext]="{
                item: item$.value,
                size: 32,
                imgClass: 'img-options-default',
              }"
            >
            </ng-container>
          }
        </div>
      }

      <div class="flex-fill-0 w-0 align-self-stretch">
        @if (choiceLabelTemp) {
          <ng-container
            [ngTemplateOutlet]="choiceLabelTemp"
            [ngTemplateOutletContext]="{ item: item$.value }"
          >
          </ng-container>
        } @else {
          <div
            class="d-flex flex-column justify-content-center h-100 overflow-newline"
          >
            <label class="mb-0">{{
              bindLabel != null ? getLabel(item$.value) : item$.label
            }}</label>
          </div>
        }
      </div>
    </div>
  </ng-template>
  <ng-template
    ng-optgroup-tmp
    let-item="item"
    let-item$="item$"
    let-index="index"
  >
    <div class="d-flex align-items-center fw-medium text-black-deep">
      @if (showCheckbox) {
        <input
          id="item-{{ index }}"
          class="form-control checkbox-default default-size me-base-l8"
          type="checkbox"
          [ngModel]="item$.selected"
        />
      }
      {{ getGroupLabel(item$.value) }}
    </div>
  </ng-template>
</ng-select>
<ng-template
  #conditionalImageTemp
  let-item="item"
  let-size="size"
  let-imgClass="imgClass"
>
  @switch (getImageType(item)) {
    @case ('svg') {
      <div [class]="imgClass" [ngClass]="getImageStyleClass(item)">
        <svg stroke="white" stroke-width="1.5" viewBox="0 0 24 24">
          <use [attr.href]="getImageSrc(item)"></use>
        </svg>
      </div>
    }
    @case ('img') {
      <div>
        <img
          alt="profile"
          class="me-base-l8"
          [class]="imgClass"
          [src]="getImage(item) || defaultImage"
        />
      </div>
    }
    @case ('person') {
      <app-profile-display
        [person]="item.context"
        [size]="size"
        [defaultPhoto]="defaultImage"
      >
      </app-profile-display>
    }
  }
</ng-template>
